// @flow

export const MARKETPLACE_AUTH_ERROR = 'Failed_to_get_Marketplace_session'
